// class CustomSliderNew extends HTMLElement {
//    constructor() {
//       super();
//       this.slider = this.querySelector('.collection-slider-list');
//       this.items = this.querySelectorAll('.product-slide');
//       this.slidesToShow = this.getAttribute('columns-desktop') || 3;
//       this.columnsMobile = this.getAttribute('columns-mobile') || 1;
//       this.columnsTablet = this.getAttribute('columns-tablet') || 2;
//       this.totalItems = this.items.length - this.slidesToShow + 1;
//       this.dataWidth = 84;
//       this.slidesToScroll = 1;
//       this.isAutoplay = this.getAttribute('autoplay') === 'true';
//       this.isLoop = this.getAttribute('loop') === 'true';
//       this.isDraggable = this.getAttribute('draggable') === 'true';
//       this.hasArrows = this.getAttribute('arrows') === 'true';
//       this.hasDots = this.getAttribute('dots') === 'true';
//       this.isDragging = false;
//       this.startX = 0;
//       this.dragDistance = 0;
//       this.locked = false;
//       this.threshold = 50;
//       this.currentIndex = 0;
//       this.init();
//    }
//    init() {
//       this.cloneSlides();
//       this.setResponsive();
//       this.createControls();
//       this.setAutoplay();
//       this.updateSlider();
//       if (this.isDraggable) {
//          this.addDraggableFeature();
//       }
//       this.addWheelFeature();
//    }
//    setResponsive() {
//       const handleResize = () => {
//          if (window.innerWidth <= 768) {
//             this.dataWidth = 100 ;
//             this.slidesToShow = this.columnsMobile;
//          } else if (window.innerWidth <= 992) {
//            let dataWidth =
//             this.slidesToShow = this.columnsTablet;
//          } else {
//            let dataWidth =
//             this.slidesToShow = this.getAttribute('columns-desktop') || 3;
//            this.dataWidth = 84
//          }
//          this.totalItems = this.items.length - this.slidesToShow + 1;
//          this.updateSlider();
//       };
//       window.addEventListener('resize', handleResize);
//       handleResize();
//    }
//   cloneSlides() {
//    const slidesToClone = parseInt(this.slidesToShow);
//    const slidesArray = Array.from(this.items);

//    const firstClones = slidesArray.slice(0, slidesToClone).map(slide => {
//       const clone = slide.cloneNode(true);
//       clone.classList.add('clone');
//       return clone;
//    });

//    const lastClones = slidesArray.slice(-slidesToClone).map(slide => {
//       const clone = slide.cloneNode(true);
//       clone.classList.add('clone');
//       return clone;
//    });

//    // Prepend last clones
//    lastClones.reverse().forEach(clone => this.slider.insertBefore(clone, this.slider.firstChild));

//    // Append first clones
//    firstClones.forEach(clone => this.slider.appendChild(clone));

//    // Update this.items to include the clones
//    this.items = this.slider.querySelectorAll('.product-slide');

//    // Set initial position after clones are added
//    this.currentIndex = slidesToClone;
// }

//    updateSlider() {
//    const slideWidth = this.dataWidth / this.slidesToShow;
//    const offset = -(this.currentIndex * slideWidth);
//    this.slider.style.transition = 'all .2s linear';
//    this.slider.style.transform = `translateX(${offset}%)`;

//    this.items.forEach((slide) => {
//       slide.style.width = `${slideWidth}%`;
//    });

//    // Handle seamless loop
//    if (this.isLoop) {
//       this.handleLoopTransition();
//    }

//    if (this.dots) {
//       const realIndex = this.currentIndex % (this.items.length - this.slidesToShow * 2);
//       this.dots.forEach((dot, index) => {
//          dot.classList.toggle('active', index === realIndex);
//       });
//    }
// }
// handleLoopTransition() {
//    const slideCount = this.items.length;
//    const clonesCount = this.slidesToShow;

//    // Wait for the transition to finish
//    this.slider.addEventListener('transitionend', () => {
//       const slideWidth = this.dataWidth / this.slidesToShow;

//       // Jump from clones back to real slides without transition
//       if (this.currentIndex >= slideCount - clonesCount) {
//          this.slider.style.transition = 'none';
//          this.currentIndex = clonesCount;
//          const offset = -(this.currentIndex * slideWidth);
//          this.slider.style.transform = `translateX(${offset}%)`;
//       }
//       if (this.currentIndex < clonesCount) {
//          this.slider.style.transition = 'none';
//          this.currentIndex = slideCount - clonesCount * 2;
//          const offset = -(this.currentIndex * slideWidth);
//          this.slider.style.transform = `translateX(${offset}%)`;
//       }
//    }, { once: true });
// }

//    createControls() {
//       if (this.slidesToShow < this.items.length) {
//          const sliderContainer = this.querySelector('.slider-container');
//          // Append arrows and dots inside .slider-container if exists
//          if (sliderContainer) {
//             if (this.hasArrows) this.createArrows(sliderContainer);
//             if (this.hasDots) this.createDots(sliderContainer);
//          }
//       }
//    }
//    createArrows(container) {
//       const prevArrow = document.createElement('button');
//       prevArrow.classList.add('prev-arrow');
//       prevArrow.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"/></svg>`;
//       prevArrow.addEventListener('click', () => {
//          this.moveSlide('prev');
//          this.stopAutoplayForDelay();
//       });
//       const nextArrow = document.createElement('button');
//       nextArrow.classList.add('next-arrow');
//       nextArrow.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg>`;
//       nextArrow.addEventListener('click', () => {
//          this.moveSlide('next');
//          this.stopAutoplayForDelay();
//       });
//       // Append arrows to the container
//       container.appendChild(prevArrow);
//       container.appendChild(nextArrow);
//    }
//    createDots(container) {
//       const dotsContainer = document.createElement('div');
//       dotsContainer.classList.add('dots');
//       this.items.forEach((_, index) => {
//          const dot = document.createElement('button');
//          dot.classList.add('dot');
//          dot.addEventListener('click', () => {
//             this.goToSlide(index);
//             this.stopAutoplayForDelay();
//          });
//          dotsContainer.appendChild(dot);
//       });
//       // Append dots container to the container
//       container.appendChild(dotsContainer);
//       this.dots = dotsContainer.querySelectorAll('.dot');
//    }
//    moveSlide(direction) {
//       if (this.isLoop) {
//          this.currentIndex = direction === 'next' ?
//             (this.currentIndex + 1) % this.totalItems :
//             (this.currentIndex - 1 + this.totalItems) % this.totalItems;
//       } else {
//          this.currentIndex = direction === 'next' ?
//             Math.min(this.currentIndex + 1, this.totalItems - 1) :
//             Math.max(this.currentIndex - 1, 0);
//       }
//       this.updateSlider();
//    }
//    goToSlide(index) {
//       this.currentIndex = index;
//       this.updateSlider();
//    }
//    setAutoplay() {
//       if (this.isAutoplay) {
//          this.autoplayIntervalId = setInterval(() => {
//             this.moveSlide('next');
//          }, 2000);
//       }
//    }
//    stopAutoplayForDelay() {
//       if (this.autoplayIntervalId) {
//          clearInterval(this.autoplayIntervalId);
//       }
//       this.autoplayTimer = setTimeout(() => {
//          this.setAutoplay();
//       }, 100);
//    }
//    addDraggableFeature() {
//       this.slider.addEventListener('mousedown', (e) => this.startDrag(e));
//       this.slider.addEventListener('mousemove', (e) => this.moveDrag(e));
//       this.slider.addEventListener('mouseup', () => this.endDrag());
//       this.slider.addEventListener('mouseleave', () => this.endDrag());
//       this.slider.addEventListener('touchstart', (e) => this.startDrag(e));
//       this.slider.addEventListener('touchmove', (e) => this.moveDrag(e));
//       this.slider.addEventListener('touchend', () => this.endDrag());
//    }
//    startDrag(e) {
//       this.isDragging = true;
//       this.startX = e.pageX || e.touches[0].pageX;
//       this.dragDistance = 0;
//       this.slider.style.cursor = 'grabbing';
//       this.locked = false;
//    }
//    moveDrag(e) {
//       if (!this.isDragging) return;
//       const currentX = e.pageX || e.touches[0].pageX;
//       this.dragDistance += currentX - this.startX;
//       if (Math.abs(this.dragDistance) >= this.threshold) {
//          if (!this.locked) {
//             this.locked = true;
//             this.moveSlide(this.dragDistance < 0 ? 'next' : 'prev');
//          }
//       }
//       this.startX = currentX;
//    }
//    endDrag() {
//       this.isDragging = false;
//       this.slider.style.cursor = 'grab';
//       setTimeout(() => {
//          this.locked = false;
//       }, 300);
//    }

// }
// customElements.define('custom-slider', CustomSliderNew);

// current code clone

// class CustomSliderNew extends HTMLElement {
//    constructor() {
//       super();
//       this.slider = this.querySelector('.collection-slider-list');
//       this.items = this.querySelectorAll('.product-slide');
//       this.slidesToShow = this.getAttribute('columns-desktop') || 3;
//       this.columnsMobile = this.getAttribute('columns-mobile') || 1;
//       this.columnsTablet = this.getAttribute('columns-tablet') || 2;
//       this.totalItems = this.items.length - this.slidesToShow + 1;
//       this.dataWidth = 84;
//       this.slidesToScroll = 1;
//       this.isAutoplay = this.getAttribute('autoplay') === 'true';
//       this.isLoop = this.getAttribute('loop') === 'true';
//       this.isDraggable = this.getAttribute('draggable') === 'true';
//       this.hasArrows = this.getAttribute('arrows') === 'true';
//       this.hasDots = this.getAttribute('dots') === 'true';
//       this.isDragging = false;
//       this.startX = 0;
//       this.dragDistance = 0;
//       this.locked = false;
//       this.threshold = 50;
//       this.currentIndex = 0;
//       this.init();
//    }
//    init() {
//       this.cloneSlides();
//       this.setResponsive();
//       this.createControls();
//       this.setAutoplay();
//       this.updateSlider();
//       if (this.isDraggable) {
//          this.addDraggableFeature();
//       }
//       this.addWheelFeature();
//    }
//    setResponsive() {
//       const handleResize = () => {
//          if (window.innerWidth <= 768) {
//             this.dataWidth = 100 ;
//             this.slidesToShow = this.columnsMobile;
//          } else if (window.innerWidth <= 992) {
//            let dataWidth =
//             this.slidesToShow = this.columnsTablet;
//          } else {
//            let dataWidth =
//             this.slidesToShow = this.getAttribute('columns-desktop') || 3;
//            this.dataWidth = 84
//          }
//          this.totalItems = this.items.length - this.slidesToShow + 1;
//          this.updateSlider();
//       };
//       window.addEventListener('resize', handleResize);
//       handleResize();
//    }
//   cloneSlides() {
//    const slidesToClone = parseInt(this.slidesToShow);
//    const slidesArray = Array.from(this.items);

//    const firstClones = slidesArray.slice(0, slidesToClone).map(slide => {
//       const clone = slide.cloneNode(true);
//       clone.classList.add('clone');
//       return clone;
//    });

//    const lastClones = slidesArray.slice(-slidesToClone).map(slide => {
//       const clone = slide.cloneNode(true);
//       clone.classList.add('clone');
//       return clone;
//    });

//    // Prepend last clones
//    lastClones.reverse().forEach(clone => this.slider.insertBefore(clone, this.slider.firstChild));

//    // Append first clones
//    firstClones.forEach(clone => this.slider.appendChild(clone));

//    // Update this.items to include the clones
//    this.items = this.slider.querySelectorAll('.product-slide');

//    // Set initial position after clones are added
//    this.currentIndex = slidesToClone;
// }

// updateSlider() {
//    const slideWidth = this.dataWidth / this.slidesToShow;
//    const offset = -(this.currentIndex * slideWidth);
//    this.slider.style.transition = 'all .2s linear';
//    this.slider.style.transform = `translateX(${offset}%)`;

//    this.items.forEach((slide) => {
//       slide.style.width = `${slideWidth}%`;
//    });

//    if (this.isLoop) {
//       this.handleLoopTransition();
//    }

//    // Update active dot
//    if (this.dots) {
//       let realIndex = this.currentIndex - this.slidesToShow;

//       if (realIndex < 0) {
//          realIndex = this.dotCount + realIndex;
//       }
//       if (realIndex >= this.dotCount) {
//          realIndex = realIndex % this.dotCount;
//       }

//       this.dots.forEach((dot, i) => {
//          dot.classList.toggle('active', i === realIndex);
//       });
//    }
// }

// handleLoopTransition() {
//    const slideCount = this.items.length;
//    const clonesCount = this.slidesToShow;

//    // Wait for the transition to finish
//    this.slider.addEventListener('transitionend', () => {
//       const slideWidth = this.dataWidth / this.slidesToShow;

//       // Jump from clones back to real slides without transition
//       if (this.currentIndex >= slideCount - clonesCount) {
//          this.slider.style.transition = 'none';
//          this.currentIndex = clonesCount;
//          const offset = -(this.currentIndex * slideWidth);
//          this.slider.style.transform = `translateX(${offset}%)`;
//       }
//       if (this.currentIndex < clonesCount) {
//          this.slider.style.transition = 'none';
//          this.currentIndex = slideCount - clonesCount * 2;
//          const offset = -(this.currentIndex * slideWidth);
//          this.slider.style.transform = `translateX(${offset}%)`;
//       }
//    }, { once: true });
// }

//    createControls() {
//       if (this.slidesToShow < this.items.length) {
//          const sliderContainer = this.querySelector('.slider-container');
//          // Append arrows and dots inside .slider-container if exists
//          if (sliderContainer) {
//             if (this.hasArrows) this.createArrows(sliderContainer);
//             if (this.hasDots) this.createDots(sliderContainer);
//          }
//       }
//    }
//    createArrows(container) {
//       const prevArrow = document.createElement('button');
//       prevArrow.classList.add('prev-arrow');
//       prevArrow.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"/></svg>`;
//       prevArrow.addEventListener('click', () => {
//          this.moveSlide('prev');
//          this.stopAutoplayForDelay();
//       });
//       const nextArrow = document.createElement('button');
//       nextArrow.classList.add('next-arrow');
//       nextArrow.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg>`;
//       nextArrow.addEventListener('click', () => {
//          this.moveSlide('next');
//          this.stopAutoplayForDelay();
//       });
//       // Append arrows to the container
//       container.appendChild(prevArrow);
//       container.appendChild(nextArrow);
//    }
// createDots(container) {
//    const dotsContainer = document.createElement('div');
//    dotsContainer.classList.add('dots');

//    // Only non-clone slides
//    const originalSlides = Array.from(this.items).filter(item => !item.classList.contains('clone'));
//    this.dotCount = originalSlides.length;
//    this.dots = [];

//    originalSlides.forEach((_, index) => {
//       const dot = document.createElement('button');
//       dot.classList.add('dot');
//       dot.addEventListener('click', () => {
//          // Adjust index to include clones at the start
//          this.currentIndex = index + this.slidesToShow;
//          this.updateSlider();
//          this.stopAutoplayForDelay();
//       });
//       dotsContainer.appendChild(dot);
//       this.dots.push(dot);
//    });

//    container.appendChild(dotsContainer);
// }

//    moveSlide(direction) {
//       if (this.isLoop) {
//          this.currentIndex = direction === 'next' ?
//             (this.currentIndex + 1) % this.totalItems :
//             (this.currentIndex - 1 + this.totalItems) % this.totalItems;
//       } else {
//          this.currentIndex = direction === 'next' ?
//             Math.min(this.currentIndex + 1, this.totalItems - 1) :
//             Math.max(this.currentIndex - 1, 0);
//       }
//       this.updateSlider();
//    }
//    goToSlide(index) {
//       this.currentIndex = index;
//       this.updateSlider();
//    }
//    setAutoplay() {
//       if (this.isAutoplay) {
//          this.autoplayIntervalId = setInterval(() => {
//             this.moveSlide('next');
//          }, 2000);
//       }
//    }
//    stopAutoplayForDelay() {
//       if (this.autoplayIntervalId) {
//          clearInterval(this.autoplayIntervalId);
//       }
//       this.autoplayTimer = setTimeout(() => {
//          this.setAutoplay();
//       }, 100);
//    }
//    addDraggableFeature() {
//       this.slider.addEventListener('mousedown', (e) => this.startDrag(e));
//       this.slider.addEventListener('mousemove', (e) => this.moveDrag(e));
//       this.slider.addEventListener('mouseup', () => this.endDrag());
//       this.slider.addEventListener('mouseleave', () => this.endDrag());
//       this.slider.addEventListener('touchstart', (e) => this.startDrag(e));
//       this.slider.addEventListener('touchmove', (e) => this.moveDrag(e));
//       this.slider.addEventListener('touchend', () => this.endDrag());
//    }
//    startDrag(e) {
//       this.isDragging = true;
//       this.startX = e.pageX || e.touches[0].pageX;
//       this.dragDistance = 0;
//       this.slider.style.cursor = 'grabbing';
//       this.locked = false;
//    }
//    moveDrag(e) {
//       if (!this.isDragging) return;
//       const currentX = e.pageX || e.touches[0].pageX;
//       this.dragDistance += currentX - this.startX;
//       if (Math.abs(this.dragDistance) >= this.threshold) {
//          if (!this.locked) {
//             this.locked = true;
//             this.moveSlide(this.dragDistance < 0 ? 'next' : 'prev');
//          }
//       }
//       this.startX = currentX;
//    }
//    endDrag() {
//       this.isDragging = false;
//       this.slider.style.cursor = 'grab';
//       setTimeout(() => {
//          this.locked = false;
//       }, 300);
//    }

// }
// customElements.define('custom-slider', CustomSliderNew);

// current clone code

class CustomSliderNewBlock extends HTMLElement {
   constructor() {
      super();
      this.slider = this.querySelector('.slider-main-parent');
      this.items = this.querySelectorAll('.slider-items');
      this.slidesToShow = this.getAttribute('columns-desktop') || 3;
      this.columnsMobile = this.getAttribute('columns-mobile') || 1;
      this.columnsTablet = this.getAttribute('columns-tablet') || 2;
      this.totalItems = this.items.length - this.slidesToShow + 1;
      this.dataWidthDesktop = this.getAttribute('width-desktop') || 100;
      this.dataWidthMobile = this.getAttribute('width-mobile') || 100;
      this.slidesToScroll = 1;
      this.isAutoplay = this.getAttribute('autoplay') === 'true';
      this.isLoop = this.getAttribute('loop') === 'true';
      this.isDraggable = this.getAttribute('draggable') === 'true';
      this.hasArrows = this.getAttribute('arrows') === 'true';
      this.hasDots = this.getAttribute('dots') === 'true';
      this.isDragging = false;
      this.startX = 0;
      this.dragDistance = 0;
      this.locked = false;
      this.threshold = 50;
      this.currentIndex = 0;
      this.init();
   }
   init() {
      this.setResponsive();
      this.createControls();
      this.setAutoplay();
      this.updateSlider();
      if (this.isDraggable) {
         this.addDraggableFeature();
      }
      // this.addWheelFeature();
   }
   setResponsive() {
      const handleResize = () => {
         if (window.outerWidth <= 767) {
            this.dataWidth = this.dataWidthMobile;
            this.slidesToShow = this.columnsMobile;
         } else if (window.outerWidth >= 768 && window.outerWidth <= 992) {
            this.slidesToShow = this.columnsTablet;
            this.dataWidth = this.dataWidthDesktop
         } else {
          this.slidesToShow = this.getAttribute('columns-desktop') || 3;
          this.dataWidth = this.dataWidthDesktop
         }
         this.totalItems = this.items.length - this.slidesToShow + 1;
         this.updateSlider();
      };
      window.addEventListener('resize', handleResize);
      handleResize();
   }
   updateSlider() {
      const slideWidth = this.dataWidth / this.slidesToShow;
      const offset = -(this.currentIndex * slideWidth);
      const lastWhiteSpace = 100 - this.dataWidth;
      const nextTotalCountNew = this.totalItems - 1;
     
     if (this.currentIndex == nextTotalCountNew) {
       
     const newOffset = offset + lastWhiteSpace;
       console.log(offset +'nnnddnnd'+newOffset);
        this.slider.style.transform = `translateX(${newOffset}%)`;
     }else{
       this.slider.style.transform = `translateX(${offset}%)`;
     }
      
      this.slider.style.transition = 'all .5s linear';
      // Set width of each slide
      this.items.forEach((slide) => {
         slide.style.width = `${slideWidth}%`;
      });
      if (this.dots) {
         this.dots.forEach((dot, index) => {
            dot.classList.toggle('active', index === this.currentIndex);
         });
      }
     console.log(this.currentIndex +' > '+ this.totalItems);
     let slidePreveIfEnable = this.querySelector('.prev-arrow');
     let ThisMaskAdded = this.querySelector('.slider-container');
     if (this.currentIndex == -0) {
       if (slidePreveIfEnable) {
         slidePreveIfEnable.classList.add('hide');
       }
       if (ThisMaskAdded) {
         ThisMaskAdded.classList.add('before');
       }
     }else{
       if (slidePreveIfEnable) {
         slidePreveIfEnable.classList.remove('hide');
       }
       if (ThisMaskAdded) {
         ThisMaskAdded.classList.remove('before');
       }
     }

     let slideNextIfEnable = this.querySelector('.next-arrow');
     let nextTotalCount = this.totalItems -1;
     if (this.currentIndex == nextTotalCount) {
       if (slideNextIfEnable) {
         slideNextIfEnable.classList.add('hide');
       }
       if (ThisMaskAdded) {
         ThisMaskAdded.classList.add('after');
       }
     }else{
       if (slideNextIfEnable) {
         slideNextIfEnable.classList.remove('hide');
       }
       if (ThisMaskAdded) {
         ThisMaskAdded.classList.remove('after');
       }
     }
   }
   createControls() {
      if (this.slidesToShow < this.items.length) {
         const sliderContainer = this.querySelector('.slider-container');
         // Append arrows and dots inside .slider-container if exists
         if (sliderContainer) {
            if (this.hasArrows) this.createArrows(sliderContainer);
            if (this.hasDots) this.createDots(sliderContainer);
         }
      }
   }
   createArrows(container) {
      const prevArrow = document.createElement('button');
      prevArrow.classList.add('prev-arrow');
      prevArrow.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"/></svg>`;
      prevArrow.addEventListener('click', () => {
         this.moveSlide('prev');
         this.stopAutoplayForDelay();
      });
      const nextArrow = document.createElement('button');
      nextArrow.classList.add('next-arrow');
      nextArrow.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg>`;
      nextArrow.addEventListener('click', () => {
         this.moveSlide('next');
         this.stopAutoplayForDelay();
      });
      // Append arrows to the container
      container.appendChild(prevArrow);
      container.appendChild(nextArrow);
   }
   createDots(container) {
      const dotsContainer = document.createElement('div');
      dotsContainer.classList.add('dots');
      this.items.forEach((_, index) => {
         const dot = document.createElement('button');
         dot.classList.add('dot');
         dot.addEventListener('click', () => {
            this.goToSlide(index);
            this.stopAutoplayForDelay();
         });
         dotsContainer.appendChild(dot);
      });
      // Append dots container to the container
      container.appendChild(dotsContainer);
      this.dots = dotsContainer.querySelectorAll('.dot');
   }
   moveSlide(direction) {
      if (this.isLoop) {
         this.currentIndex = direction === 'next' ?
            (this.currentIndex + 1) % this.totalItems :
            (this.currentIndex - 1 + this.totalItems) % this.totalItems;
      } else {
         this.currentIndex = direction === 'next' ?
            Math.min(this.currentIndex + 1, this.totalItems - 1) :
            Math.max(this.currentIndex - 1, 0);
      }
      this.updateSlider();
   }
   goToSlide(index) {
      this.currentIndex = index;
      this.updateSlider();
   }
   setAutoplay() {
      if (this.isAutoplay) {
         this.autoplayIntervalId = setInterval(() => {
            this.moveSlide('next');
         }, 7000);
      }
   }
   stopAutoplayForDelay() {
      if (this.autoplayIntervalId) {
         clearInterval(this.autoplayIntervalId);
      }
      this.autoplayTimer = setTimeout(() => {
         this.setAutoplay();
      }, 100);
   }
   addDraggableFeature() {
      this.slider.addEventListener('mousedown', (e) => this.startDrag(e));
      this.slider.addEventListener('mousemove', (e) => this.moveDrag(e));
      this.slider.addEventListener('mouseup', () => this.endDrag());
      this.slider.addEventListener('mouseleave', () => this.endDrag());
      this.slider.addEventListener('touchstart', (e) => this.startDrag(e));
      this.slider.addEventListener('touchmove', (e) => this.moveDrag(e));
      this.slider.addEventListener('touchend', () => this.endDrag());
   }
   startDrag(e) {
      this.isDragging = true;
      this.startX = e.pageX || e.touches[0].pageX;
      this.dragDistance = 0;
      this.slider.style.cursor = 'grabbing';
      this.locked = false;
   }
   moveDrag(e) {
      if (!this.isDragging) return;
      const currentX = e.pageX || e.touches[0].pageX;
      this.dragDistance += currentX - this.startX;
      if (Math.abs(this.dragDistance) >= this.threshold) {
         if (!this.locked) {
            this.locked = true;
            this.moveSlide(this.dragDistance < 0 ? 'next' : 'prev');
         }
      }
      this.startX = currentX;
   }
   endDrag() {
      this.isDragging = false;
      this.slider.style.cursor = 'grab';
      setTimeout(() => {
         this.locked = false;
      }, 300);
   }

}
customElements.define('custom-block-slider', CustomSliderNewBlock);

// document.addEventListener("scroll", function () {
//   const footer = document.querySelector(".site-footer");
//   const scrollY = window.scrollY;

//   if (footer) {
//     footer.style.transform = `translateY(${scrollY * -0.2}px)`; // adjust factor if needed
//   }
// });

class CustomSliderNew extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector(".slider-main-parent");
    this.items = this.querySelectorAll(".slider-items");
    this.slidesToShow = this.getAttribute("columns-desktop") || 3;
    this.columnsMobile = this.getAttribute("columns-mobile") || 1;
    this.columnsTablet = this.getAttribute("columns-tablet") || 2;
    this.totalItems = this.items.length - this.slidesToShow + 1;
    this.dataWidthDesktop = this.getAttribute("width-desktop") || 100;
    this.dataWidthMobile = this.getAttribute("width-mobile") || 100;
    this.slidesToScroll = 1;
    this.isAutoplay = this.getAttribute("autoplay") === "true";
    this.isLoop = this.getAttribute("loop") === "true";
    this.isDraggable = this.getAttribute("draggable") === "true";
    this.hasArrows = this.getAttribute("arrows") === "true";
    this.hasDots = this.getAttribute("dots") === "true";
    this.isDragging = false;
    this.startX = 0;
    this.dragDistance = 0;
    this.locked = false;
    this.threshold = 50;
    this.currentIndex = 0;
    this.init();
  }
  init() {
    this.cloneSlides();
    this.setResponsive();
    this.createControls();
    this.currentIndex = 1; // 👈 Start at first real slide
    this.setAutoplay();
    this.updateSlider();
    if (this.isDraggable) this.addDraggableFeature();

    this.slider.addEventListener("transitionend", () => this.handleLooping());
  }

  setResponsive() {
    const handleResize = () => {
      if (window.outerWidth <= 767) {
        this.dataWidth = this.dataWidthMobile;
        this.slidesToShow = this.columnsMobile;
      } else if (window.outerWidth >= 768 && window.outerWidth <= 992) {
        this.slidesToShow = this.columnsTablet;
        this.dataWidth = this.dataWidthDesktop;
      } else {
        this.slidesToShow = this.getAttribute("columns-desktop") || 3;
        this.dataWidth = this.dataWidthDesktop;
      }
      this.totalItems = this.items.length - this.slidesToShow + 1;
      this.updateSlider();
    };
    window.addEventListener("resize", handleResize);
    handleResize();
  }
  updateSlider() {
    const slideWidth = this.dataWidth / this.slidesToShow;
    const offset = -(this.currentIndex * slideWidth);
    this.slider.style.transition = "all 0.5s ease";
    this.slider.style.transform = `translateX(${offset}%)`;

    this.items.forEach((slide) => {
      slide.style.width = `${slideWidth}%`;
    });

    if (this.dots) {
      const realIndex =
        (this.currentIndex - 1 + this.totalItems) % this.totalItems;
      this.dots.forEach((dot, i) => {
        dot.classList.toggle("active", i === realIndex);
      });
    }
  }
  handleLooping() {
    const slideWidth = this.dataWidth / this.slidesToShow;

    if (this.items[this.currentIndex].classList.contains("clone")) {
      this.slider.style.transition = "none";
      if (this.currentIndex === 0) {
        this.currentIndex = this.items.length - 2;
      } else if (this.currentIndex === this.items.length - 1) {
        this.currentIndex = 1;
      }
      this.slider.offsetHeight;
      const offset = -(this.currentIndex * slideWidth);
      this.slider.style.transform = `translateX(${offset}%)`;
    }
  }

  cloneSlides() {
    const first = this.items[0].cloneNode(true);
    const last = this.items[this.items.length - 1].cloneNode(true);
    first.classList.add("clone");
    last.classList.add("clone");

    this.slider.appendChild(first);
    this.slider.insertBefore(last, this.items[0]);

    this.items = this.querySelectorAll(".slider-items");
  }

  createControls() {
    if (this.slidesToShow < this.items.length) {
      const sliderContainer = this.querySelector(".slider-container");
      // Append arrows and dots inside .slider-container if exists
      if (sliderContainer) {
        if (this.hasArrows) this.createArrows(sliderContainer);
        if (this.hasDots) this.createDots(sliderContainer);
      }
    }
  }
  createArrows(container) {
    const prevArrow = document.createElement("button");
    prevArrow.classList.add("prev-arrow");
    prevArrow.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"/></svg>`;
    prevArrow.addEventListener("click", () => {
      // this.moveSlide("prev");
      // this.stopAutoplayForDelay();
      if (!prevArrow.classList.contains('disabled')) {
      prevArrow.classList.add('disabled');  // Add disabled
      this.moveSlide('prev');
      this.stopAutoplayForDelay();
      setTimeout(() => {
        prevArrow.classList.remove('disabled'); // Remove after 1s
      }, 500);
    }
    });
    const nextArrow = document.createElement("button");
    nextArrow.classList.add("next-arrow");
    nextArrow.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg>`;
    nextArrow.addEventListener("click", () => {
      // this.moveSlide("next");
      // this.stopAutoplayForDelay();
      if (!nextArrow.classList.contains('disabled')) {
      nextArrow.classList.add('disabled');  // Add disabled
      this.moveSlide('next');
      this.stopAutoplayForDelay();
      setTimeout(() => {
        nextArrow.classList.remove('disabled'); // Remove after 1s
      }, 500);
    }
    });
    // Append arrows to the container
    container.appendChild(prevArrow);
    container.appendChild(nextArrow);
  }
  createDots(container) {
    const dotsContainer = document.createElement("div");
    dotsContainer.classList.add("dots");
    this.items.forEach((_, index) => {
      const dot = document.createElement("button");
      dot.classList.add("dot");
      dot.addEventListener("click", () => {
        this.goToSlide(index);
        this.stopAutoplayForDelay();
      });
      dotsContainer.appendChild(dot);
    });
    // Append dots container to the container
    container.appendChild(dotsContainer);
    this.dots = dotsContainer.querySelectorAll(".dot");
  }
 
  moveSlide(direction) {
    const maxIndex = this.items.length - 1;
    if (direction === "next") {
      this.currentIndex++;
      if (this.currentIndex > maxIndex) {
        this.currentIndex = 1; // Skip to real first slide after loop
        this.slider.style.transition = "none"; // Disable transition during fast click
        this.slider.style.transform = `translateX(0)`; // Jump immediately
        setTimeout(() => {
          this.slider.style.transition = "all 0.5s ease"; // Re-enable transition after jump
        }, 50); // Wait a short time for smooth transition
      }
    } else {
      this.currentIndex--;
      if (this.currentIndex < 0) {
        this.currentIndex = maxIndex - 1; // Skip to real last slide after loop
        this.slider.style.transition = "none";
        this.slider.style.transform = `translateX(-${
          (maxIndex - 1) * (100 / this.slidesToShow)
        }%)`; // Jump to last slide
        setTimeout(() => {
          this.slider.style.transition = "all 0.5s ease";
        }, 50);
      }
    }
    this.updateSlider();
  }

  goToSlide(index) {
    this.currentIndex = index;
    this.updateSlider();
  }
  setAutoplay() {
    if (this.isAutoplay) {
      this.autoplayIntervalId = setInterval(() => {
        this.moveSlide("next");
      }, 7000);
    }
  }
  stopAutoplayForDelay() {
    if (this.autoplayIntervalId) {
      clearInterval(this.autoplayIntervalId);
    }
    this.autoplayTimer = setTimeout(() => {
      this.setAutoplay();
    }, 100);
  }
  addDraggableFeature() {
    this.slider.addEventListener("mousedown", (e) => this.startDrag(e));
    this.slider.addEventListener("mousemove", (e) => this.moveDrag(e));
    this.slider.addEventListener("mouseup", () => this.endDrag());
    this.slider.addEventListener("mouseleave", () => this.endDrag());
    this.slider.addEventListener("touchstart", (e) => this.startDrag(e));
    this.slider.addEventListener("touchmove", (e) => this.moveDrag(e));
    this.slider.addEventListener("touchend", () => this.endDrag());
  }
  startDrag(e) {
    this.isDragging = true;
    this.startX = e.pageX || e.touches[0].pageX;
    this.dragDistance = 0;
    this.slider.style.cursor = "grabbing";
    this.locked = false;
  }
  moveDrag(e) {
    if (!this.isDragging) return;
    const currentX = e.pageX || e.touches[0].pageX;
    this.dragDistance += currentX - this.startX;
    if (Math.abs(this.dragDistance) >= this.threshold) {
      if (!this.locked) {
        this.locked = true;
        this.moveSlide(this.dragDistance < 0 ? "next" : "prev");
      }
    }
    this.startX = currentX;
  }
  endDrag() {
    this.isDragging = false;
    this.slider.style.cursor = "grab";
    setTimeout(() => {
      this.locked = false;
    }, 300);
  }
}
customElements.define("custom-slider", CustomSliderNew);

setTimeout(() => {
  // Create the new select element
  const selectEl = document.createElement('select');
  selectEl.setAttribute('name', 'id');
  selectEl.setAttribute('data-product-select', '');
  selectEl.className = 'product-single__variants no-js';
  selectEl.setAttribute('data-gtm-form-interact-field-id', '0');

  // Find the target input element
  const inputEl = document.querySelector('input.pmpr_input[ref="variantId"][name="id"]');

  // Insert the select element after the input
  if (inputEl && inputEl.parentNode) {
    inputEl.parentNode.insertBefore(selectEl, inputEl.nextSibling);
  }
}, 300);

// safe code 
window.addEventListener('load', function () {
  window.addEventListener('resize', function() {
    scrolled();
  });
  scrolled();
  function scrolled() {
  if (window.innerWidth < 769) {
    const addBtn = document.querySelector('.add-to-cart');
    if(addBtn && addBtn.dataset.stickyCartbtn == 'true') {
      
        const productForm = document.querySelector('.product-single__form');
        const positionFromTop = productForm.getBoundingClientRect().top + window.scrollY;
    
        if (!addBtn && !productForm) return;
    
          document.addEventListener('click', function (event) {
          const fixedBtn = event.target.closest('.fixedButton');
          if (fixedBtn) {
            setTimeout(() => {
              const errorMsg = document.querySelector('.errors');
              if (document.body.contains(errorMsg)) {
                const errorMsgPos = errorMsg.getBoundingClientRect().top + window.scrollY;
                window.scrollTo({
                  top: errorMsgPos - 70,
                  behavior: 'smooth'
                });
              }
            }, 700);
          }
        });
    
        function isElementVisible(el) {
          const rect = el.getBoundingClientRect();
          const viewportHeight = window.innerHeight - ( window.innerHeight * 0.1 );
          return rect.top < viewportHeight && rect.bottom > 0;
        }
    
        document.addEventListener('scroll', function () {
          if (isElementVisible(productForm) || positionFromTop < window.scrollY) {
            addBtn.classList.add('fixedButton');
          } else {
            addBtn.classList.remove('fixedButton');
          }
        });
    
        // Also run on load in case the form is visible initially
        if (isElementVisible(productForm)) {
          addBtn.classList.add('fixedButton');
        }
      }
    }
  }
});
